<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="60%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div class="col-12 col-md-4">
            <fg-input
              type="text"
              :label="`${$t('common_words.code')}: *`"
              v-model="model.code"
              v-validate="modelValidations.code"
              name="common_words.code"
              :error="getError('common_words.code', true)"
              :disabled="disabledField"
              @click="handleClickOnCode('samples.ground_types')"
            >
            </fg-input>
          </div>
          <div class="col-12 col-md-8">
            <fg-input
              type="text"
              :label="`${$t('common_words.name')}: *`"
              v-model="model.name"
              v-validate="modelValidations.name"
              name="common_words.name"
              :error="getError('common_words.name', true)"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <fg-input
              type="number"
              step="0.01"
              :label="`${$t('irrigation.irrigation_coefficient')}: `"
              v-model="model.irrigation_coefficient"
            >
            </fg-input>
          </div>
          <div class="col-12 col-md-4">
            <fg-input
              type="number"
              step="0.01"
              :label="`${$t('irrigation.wilting_point')}: `"
              v-model="model.wilting_point"
            >
            </fg-input>
          </div>
          <div class="col-12 col-md-4">
            <fg-input
              type="number"
              step="0.01"
              :label="`${$t('irrigation.saturation_point')}: `"
              v-model="model.saturation_point"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group has-label">
              <label>{{ $t('common_words.description') }}:</label>
              <br />
              <el-input
                maxlength="300"
                show-word-limit
                class="shadow-sm"
                type="textarea"
                :rows="5"
                placeholder="..."
                v-model="model.description"
              ></el-input>
              <br />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <span class="text-muted" style="font-size: 16px"
              >{{ $t('common_words.image') }}:
            </span>
            <el-upload
              multiple
              ref="uploadSoilTypeImage"
              class="upload-demo"
              :action="getAxiosURL + '/auth/grounds/types/uploadImage'"
              :data="uploadData"
              :headers="headerInfo"
              :limit="1"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :on-success="handleSuccess"
              :file-list="fileList"
              :auto-upload="false"
              :accept="acceptedFilesString"
            >
              <el-button size="small mt-1" type="primary">{{
                $t('common_words.click_to_load')
              }}</el-button>
              <div slot="tip" class="mt-2 el-upload__tip">
                {{ $t('common_words.file_size_limit_fivemb') }}
              </div>
            </el-upload>
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinUpload from 'src/mixins/mixin-upload';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-create',
  mixins: [MixinDialog, MixinForm, MixinUpload, MixinValidations],
  data() {
    return {
      disabledField: false,
      model: {
        code: null,
        name: null,
        description: null,
        irrigation_coefficient: null,
        wilting_point: null,
        saturation_point: null,
        image: null,
        fileList: [],
      },
      modelValidations: {
        code: { required: true },
        name: { required: true },
      },
    };
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    updateDisabledField(value) {
      this.disabledField = value;
    },
    /**
     * Método para validar un formulario de edición o guardado
     */
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.model.fileList && this.model.fileList.length > 0) {
            sessionStorage.setItem('before-upload', 1);
          }
          this.$emit('addEdit', this.model);
        }
      });
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };
      this.uploadData.id = editForm.id;
      if (isset(editForm.image)) {
        this.fileList = [
          { name: editForm.image.replace(`${editForm.id}/`, '') },
        ];
      }
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
